import React from "react";

import styled, { css } from "styled-components";

import PropTypes from "prop-types";

const fontSizes = {
    small: "1.2rem",
    regular: "1.4rem",
    large: "1.6rem",
};

const fontWeights = {
    regular: "400",
    bold: "500",
};

const StyledTextContainer = styled.div`
    font-size: ${({ fontSize }) => fontSizes[fontSize]};
    font-weight: ${({ fontWeight }) => fontWeights[fontWeight]};

    ${({ color }) => color && `color: ${color};`}

    /* 기본 스타일 추가 영역 */
    line-height: 1.4;

    /* 왼쪽 바 표시 */
    ${({ withBarType }) =>
        withBarType &&
        css`
            padding-left: 8px; /* 왼쪽 바와 텍스트 사이 간격 */
            border-left: 2px solid var(--color-TitleBar);
        `}

    /* 텍스트가 길어질 경우 생략 부호(...) 표시 */
    ${({ ellipsis }) =>
        ellipsis &&
        css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        `}
`;

function StyledText({
    children,
    fontSize = "regular",
    fontWeight = "regular",
    color = null,
    withBarType = false,
    ellipsis = false,
    ...rest
}) {
    return (
        <StyledTextContainer
            fontSize={fontSize}
            fontWeight={fontWeight}
            color={color}
            withBarType={withBarType}
            ellipsis={ellipsis}
            {...rest}
        >
            {children}
        </StyledTextContainer>
    );
}

StyledText.propTypes = {
    /** 텍스트 내용 */
    children: PropTypes.node,
    /** 텍스트 크기 */
    fontSize: PropTypes.oneOf(["small", "regular", "large"]),
    /** 텍스트 굵기 */
    fontWeight: PropTypes.oneOf(["regular", "bold"]),
    /** 텍스트 색상 (CSS color 값) */
    color: PropTypes.string,
    /** 왼쪽에 강조 바 표시 여부 */
    withBarType: PropTypes.bool,
    /** 텍스트가 길어질 경우 생략 부호(...) 표시 여부 */
    ellipsis: PropTypes.bool,
};

export default StyledText;
